export default __webpack_public_path__ + "pypi/streamlit-1.35.0-cp312-none-any.whl";